import { render, staticRenderFns } from "./dentify.vue?vue&type=template&id=286dd564"
import script from "./dentify.vue?vue&type=script&lang=js"
export * from "./dentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports